import "./ui.css";

export function Button({
  children,
  variant = "filled", // filled | outlined | text
  tone = "primary", // primary | error
  fullWidth,
  disabled,
  ...rest
}) {
  const cls = ["tg-btn", `tg-btn--${variant}`, `tg-btn--${tone}`, fullWidth ? "tg-btn--full" : ""]
    .filter(Boolean)
    .join(" ");
  return (
    <button className={cls} disabled={disabled} {...rest}>
      {children}
    </button>
  );
}

export function IconButton({ children, label, ...rest }) {
  return (
    <button className="tg-icon-btn" aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`tg-card ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function TextField({ label, value, onChange, type = "text", readOnly, suffix, error, ...rest }) {
  return (
    <label className="tg-field">
      <span className="tg-field__label">{label}</span>
      <span className="tg-field__control">
        <input
          className={`tg-field__input ${error ? "tg-field__input--error" : ""}`}
          type={type}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          {...rest}
        />
        {suffix && <span className="tg-field__suffix">{suffix}</span>}
      </span>
      {error && <span className="tg-field__error">{error}</span>}
    </label>
  );
}

export function Spinner({ size = 22 }) {
  return (
    <span
      className="tg-spinner"
      style={{ width: size, height: size, borderWidth: Math.max(2, size / 10) }}
      role="status"
      aria-label="Loading"
    />
  );
}

export function UsageBar({ percent, danger }) {
  const clamped = Math.min(100, Math.max(0, percent || 0));
  return (
    <div className="tg-usagebar">
      <div
        className={`tg-usagebar__fill ${danger ? "tg-usagebar__fill--danger" : ""}`}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}

export function StatusDot({ status }) {
  const cls =
    status === "green"
      ? "tg-dot--green"
      : status === "red"
      ? "tg-dot--red"
      : "tg-dot--neutral";
  return <span className={`tg-dot ${cls}`} />;
}

export function Badge({ children, tone = "primary" }) {
  return <span className={`tg-badge tg-badge--${tone}`}>{children}</span>;
}

export function EmptyState({ children }) {
  return <div className="tg-empty">{children}</div>;
}

export function Toast({ result }) {
  if (!result) return null;
  const isSuccess = result.type === "success";
  return (
    <div className={`tg-toast ${isSuccess ? "tg-toast--success" : "tg-toast--error"}`}>
      {isSuccess ? "✓" : "!"} {result.message}
    </div>
  );
}
